import { memo, useCallback, useState } from "react"
import styled from "styled-components"
import Button, { ButtonProps } from "./EvtKit/button/Button"
import Modal from "./EvtKit/modal/Modal"
import AttentionIcon from "./icons/AttentionIcon"
import BodyText from "./Typography/BodyText"
import Heading from "./Typography/Heading"

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const ButtonContent = styled.div`
  display: flex;
  width: 160px;
`

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const ButtonContainer = styled.div`
  justify-content: flex-end;
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
`

interface ButtonWithConfirmationProps extends ButtonProps {
  actionWithConfirmation: () => void
  actionHeading: string
  actionText: string
}

export const ButtonWithConfirmation = (props: ButtonWithConfirmationProps) => {
  const { actionWithConfirmation, actionHeading, actionText, ...rest } = props

  const [isOpen, setIsOpen] = useState(false)

  const handleClose = useCallback(() => {
    setIsOpen(false)
  }, [])

  const handleOpen = useCallback(() => {
    setIsOpen(true)
  }, [])

  return (
    <Container>
      <Modal openModal={isOpen} closeModal={handleClose} size="sm">
        <ModalContent>
          <IconContainer>
            <AttentionIcon />
            <Heading color="informative" variant="h4">
              {actionHeading}
            </Heading>
          </IconContainer>
          <BodyText color="gray-dark" size="medium" weight="light" className="fill-width">
            {actionText}
          </BodyText>
          <BodyText size="medium" weight="bold">
            Tem certeza de que deseja continuar com esta ação?
          </BodyText>
          <ButtonContainer>
            <ButtonContent>
              <Button label="Sim" className={`fill-width secondary-attention`} onClick={actionWithConfirmation} />
            </ButtonContent>
            <ButtonContent>
              <Button label="Não" className={`fill-width attention-attention`} onClick={handleClose} />
            </ButtonContent>
          </ButtonContainer>
        </ModalContent>
      </Modal>

      <Button {...rest} onClick={handleOpen} />
    </Container>
  )
}

export default memo(ButtonWithConfirmation)
